export const getBaseOptions = () => ({
  scales: {
    x: {
      ticks: {
        padding: 16,
      },
      grid: {
        drawTicks: false,
      },
    },
    y: {
      ticks: {
        padding: 10,
      },
      grid: {
        drawTicks: false,
      },
    },
  },
  plugins: {
    tooltip: {
      padding: 20,
      bodySpacing: 10,
      boxPadding: 10,
      boxWidth: 12,
      boxHeight: 12,
      titleFont: {
        size: 14,
      },
      titleColor: "#FFFFFFCC",
      bodyFont: {
        size: 14,
      },
    },
  },
});
